<template>
  <!--消息中心页面-->
  <tk-container
    infinite-scroll
    @loadingMore="getMessages"
  >
    <!--头部-->
    <my-header slot="header">消息中心</my-header>
    <!--内容-->
    <template v-if="messageNotification.length">
      <div
        class="m-x-12"
        v-for="(s, index) in messageNotification"
        :key="index"
      >
        <tk-flex center class="p-y-12">
          <div class="card-time">{{s.createdAt | datetime}}</div>
        </tk-flex>
        <card :width="100"
              :height="54"
        >
          <div class="font-bold">{{s.messageTitle}}</div>
          <div class="m-t-5 card-content van-multi-ellipsis--l3 text-area-pre">{{s.IntroductionEvent}}</div>
          <tk-flex class="m-t-12" center @click.native="$push({ path: '/common/messageDetail', query: { id: s.objectId }})">
            <tkui-badge :show="!s.userRecords.includes(userInfo.objectId)">
              <div class="card-end">查看详情</div>
            </tkui-badge>
          </tk-flex>
        </card>
      </div>
    </template>

  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      messageNotification: [] // 消息通知
    }
  },
  mounted () {
    this.setStatusBar('dark')
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    async getMessages (page, next) {
      let messageNotification = await this.$tkParse.getList(`/classes/messageNotification`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-createdAt'
        }
      })
      messageNotification = messageNotification.map(s => {
        if (!s.userRecords) { s.userRecords = [] }
        return s
      })
      this.messageNotification = [...this.messageNotification, ...messageNotification]
      if (messageNotification.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    }
  },
  hasFlash () {
    let id = this.$getFlash('messageId')
    if (id) {
      let singleIndex = this.messageNotification.findIndex(s => { return s.objectId === id })
      if (singleIndex !== -1) {
        if (!this.messageNotification[singleIndex].userRecords.includes(this.userInfo.objectId)) {
          this.messageNotification[singleIndex].userRecords.push(this.userInfo.objectId)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
/*消息样式*/
  .card-time {
    min-width: 120px;
    height: 20px;
    background: rgba(231,231,231,1);
    border-radius: 10px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
  }
/*样式*/
.card-content {
  font-size: 15px;
  color: rgba(153, 153, 153, 1);
}
.card-end {
    font-size: 15px;
    color: rgba(129, 140, 163, 1);
  }
/*红点提示样式*/
::v-deep {
  .tkui-badge .tkui-badge-wrapper.dot {
    right: -15px !important;
  }
}
</style>
